import React from "react";
import { Image } from "react-bootstrap";

const RelevantImages = ({ imageUrls }) => {
  return (
    <div className="tab-content-scrollable">
      {imageUrls.map((url, index) => (
        <div key={index} className="text-center mb-3 border shadow">
          <Image src={url} alt={`Relevant Document ${index + 1}`} fluid />
        </div>
      ))}
    </div>
  );
};

export default RelevantImages;
